import { FC, useMemo, useState } from "react";
import { PickerModal, PickerTabs } from "./PickerModal";
import { SAMPLE_VOICES } from "../data";

const SearchIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.3-4.3" />
  </svg>
);

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <path d="m5 13 4 4L19 7" />
  </svg>
);

/**
 * 音色选择弹窗（公共组件）
 * - 公共音色 / 我的音色 页签 + 搜索
 * - 单选卡片，选中态蓝描边 + 蓝色对勾
 */
export const VoicePickerModal: FC<{
  value: string;
  onClose: () => void;
  onConfirm: (name: string) => void;
}> = ({ value, onClose, onConfirm }) => {
  const [tab, setTab] = useState("public");
  const [keyword, setKeyword] = useState("");
  const [picked, setPicked] = useState(value);

  const list = useMemo(
    () =>
      SAMPLE_VOICES.filter(
        (v) =>
          (tab === "public" ? v.scope === "public" : v.scope === "mine") &&
          v.name.includes(keyword.trim())
      ),
    [tab, keyword]
  );

  return (
    <PickerModal
      title="音色选择"
      subtitle="选择 1 个音色用于当前口播作品"
      width={760}
      onClose={onClose}
      footerLeft={`已选择 ${picked ? 1 : 0} / 1`}
      confirmText="确认选择"
      confirmDisabled={!picked}
      onConfirm={() => onConfirm(picked)}
    >
      <PickerTabs
        items={[
          { key: "public", label: "公共音色" },
          { key: "mine", label: "我的音色" },
        ]}
        value={tab}
        onChange={setTab}
      />
      <label className="adh-vpk-search">
        <SearchIcon />
        <input
          placeholder="搜索音色名称"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
        />
      </label>
      <div className="adh-vpk-list">
        {list.map((v) => (
          <button
            key={v.id}
            type="button"
            className={`adh-vpk-card${picked === v.name ? " active" : ""}`}
            onClick={() => setPicked(v.name)}
          >
            <span className="adh-vpk-icon" style={{ background: v.color }}>{v.name.slice(0, 1)}</span>
            <span className="adh-vpk-info">
              <strong>{v.name}</strong>
              <small>{v.meta}</small>
            </span>
            <span className="adh-vpk-check">{picked === v.name && <CheckIcon />}</span>
          </button>
        ))}
        {list.length === 0 && <div className="adh-vpk-empty">没有匹配的音色</div>}
      </div>
    </PickerModal>
  );
};
